export const configList = [
	{
		label: '部门',
		key: 'deptIds',
		type: 'component',
		component: () => import('@/components/business/deptTreeSelect/deptTreeSelect.vue'),
		isShow: true,
		returnArray: true,
		collapseTags: true,
		size: 'small',
	},
	{
		label: '团长',
		key: 'authority_id',
		type: 'component',
		component: () => import('@/components/commanderSelect/index.vue'),
		isShow: true,
		isConcact: true, //是否联动
	},
	{
		label: '员工',
		key: 'userId',
		type: 'component',
		component: () => import('@/components/business/staffSelect'),
		isShow: true,
	},
	{
		label: '仅查看在职账号',
		key: 'onJobFlag',
		type: 'radio',
		options: [
			{
				label: '是',
				value: '1',
			},
			{
				label: '否',
				value: '0',
			},
		],
		isShow: true,
	},
];
